<script setup lang="ts">
import api from "@/api";
import { getBasePageUrlFromRole } from "@/assets/js/helpers";
import { useDefaultStore } from "@/store";
import { useSessionStore } from "@/store/session";

definePage({
	name: "auth.validation",
});

const route = useRoute();
const token = computed(() => route.query.token as string);
// const isValidToken = computed(() => !!token.value);
const userType = computed(() => route.query.usr_type as string);
const isSchoolAdmin = computed(() => userType.value === "sc");

const sessionStore = useSessionStore();
const defaultStore = useDefaultStore();
const isError = ref(false);

async function verifyToken() {
	try {
		await api.authVerifyCreate({ token: token.value });
		if (sessionStore.isLoggedIn) {
			sessionStore.renewToken();
		}
		setupAnimations();
	} catch (e) {
		console.error(e);
		isError.value = true;
	}
}

const showImages = ref(false);
const showTitle = ref(false);
const showText = ref(false);
function setupAnimations() {
	showTitle.value = true;
	setTimeout(() => {
		showImages.value = true;
		showText.value = true;
	}, 1500);
}
onMounted(() => {
	verifyToken();
});

const router = useRouter();

const getTo = computed<any>(() => {
	return sessionStore.isLoggedIn
		? { name: getBasePageUrlFromRole(sessionStore.roleId) }
		: { name: "auth.login" };
});
function navigate() {
	router.push(getTo.value);
}
</script>
<template>
	<div
		v-if="!isError"
		class="wrap"
	>
		<transition
			name="fade-up-text"
			tag="div"
			class="title"
		>
			<h1 v-if="showTitle">{{ $t("app.auth.welcome") }}</h1>
		</transition>
		<div class="container">
			<transition
				tag="div"
				name="fade-up-text"
				class="content"
			>
				<div v-if="showText">
					<label class="sub-title">
						{{ $t("app.auth.successfullyValidated") }}
					</label>
					<p>
						{{
							isSchoolAdmin
								? $t("app.auth.validationTextSchoolAdmin")
								: $t("app.auth.validationText")
						}}
					</p>
					<p-button @click="navigate">
						{{
							isSchoolAdmin || sessionStore.isLoggedIn
								? $t("app.base.continue")
								: $t("app.auth.setUp")
						}}
					</p-button>
				</div>
			</transition>
			<transition name="validation-slider-left">
				<div
					v-if="showImages"
					class="nice-lady-wrap"
				>
					<img
						src="@/assets/image/nice-lady.png"
						alt="nice-lady"
					/>
				</div>
			</transition>
			<transition name="validation-slider-right">
				<div
					v-if="showImages"
					class="nice-flowers-wrap"
				>
					<img
						src="@/assets/image/nice-flowers.png"
						alt="nice-flowers"
					/>
				</div>
			</transition>
		</div>
	</div>
	<div
		v-else
		class="h-full flex justify-center items-center text-center flex-col gap-4"
	>
		<h1 class="text-3xl font-semibold">
			{{ $t("app.base.somethingWrong") }}
		</h1>
		<p class="text-xl">
			{{ $t("app.base.somethingWrongText") }}
			<br />
			{{
				$t("app.base.tryAgainContactAdmin", {
					supportEmail: defaultStore.supportEmail,
				})
			}}
		</p>
		<p-button
			as="router-link"
			:to="{ name: 'auth.login' }"
		>
			{{
				$t("app.base.back") +
				" " +
				$t("app.base.to").toLowerCase() +
				" " +
				$t("app.homepage")
			}}
		</p-button>
	</div>
</template>
<style scoped lang="scss">
.wrap {
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	gap: 1rem;
	width: 50vw;
	overflow: visible;
	.title {
		font-weight: 500;
		text-align: center;
		font-size: 2rem;
	}

	@media screen and (max-width: 1024px) {
		width: 100%;
	}
	.container {
		padding: 2rem 2rem 150px;
		background-color: $daidai-light-blue;
		position: relative;
		border-radius: 30px;
		box-shadow: 4px 4px 15px #3332551a;

		@media screen and (max-width: 1024px) {
			width: 100%;
			padding: 1rem;
		}
		.content {
			display: flex;
			flex-direction: column;
			gap: 1rem;
			align-items: center;
			justify-content: center;
			padding: 2rem;
		}
	}
	.nice-lady-wrap,
	.nice-flowers-wrap {
		position: absolute;
		bottom: 0;

		@media screen and (max-width: 1024px) {
			display: none;
		}
	}
	.nice-lady-wrap {
		left: -15%;
	}
	.nice-flowers-wrap {
		right: -25%;
	}
}
</style>
